import { createRoot } from 'react-dom/client';
import App from './app/App';
if (DEV_MODE) {
    require('./style.css');
    console.log('DEV MODE');
}
const container = document.getElementById('root');
/* istanbul ignore next */
if (container === null)
    throw new Error('No root element found');
const root = createRoot(container);
root.render(App());
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLGtCQUFrQixDQUFBO0FBQzdDLE9BQU8sR0FBRyxNQUFNLFdBQVcsQ0FBQTtBQUUzQixJQUFJLFFBQVEsRUFBRSxDQUFDO0lBQ1gsT0FBTyxDQUFDLGFBQWEsQ0FBQyxDQUFBO0lBQ3RCLE9BQU8sQ0FBQyxHQUFHLENBQUMsVUFBVSxDQUFDLENBQUE7QUFDM0IsQ0FBQztBQUVELE1BQU0sU0FBUyxHQUFHLFFBQVEsQ0FBQyxjQUFjLENBQUMsTUFBTSxDQUFDLENBQUE7QUFDakQsMEJBQTBCO0FBQzFCLElBQUksU0FBUyxLQUFLLElBQUk7SUFBRSxNQUFNLElBQUksS0FBSyxDQUFDLHVCQUF1QixDQUFDLENBQUE7QUFDaEUsTUFBTSxJQUFJLEdBQUcsVUFBVSxDQUFDLFNBQVMsQ0FBQyxDQUFBO0FBQ2xDLElBQUksQ0FBQyxNQUFNLENBQUMsR0FBRyxFQUFFLENBQUMsQ0FBQSJ9